class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
      const reformerProperty = this.closest(".cart-item").querySelector(
        'span[data-property-key="_bundle-product"]'
      );
      const timestamp = this.closest(".cart-item").querySelector(
        'span[data-property-key="_timeStamp"]'
      );
      const rentalProperty = this.closest(".cart-item").querySelector("span[data-rental]");
      if (rentalProperty) {
        cartItems?.enableLoading(this.dataset.index);
        this.removeRentals();
        return;
      }
      if (reformerProperty) {
        const reformerId = reformerProperty.getAttribute("data-property-value");
        const timestampValue = timestamp.getAttribute("data-property-value");
        cartItems?.enableLoading(this.dataset.index);
        this.removeReformerInclusions(reformerId, timestampValue);
        return;
      }
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }

  removeRentals() {
    fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((cart) => {
        const items = cart.items;
        const attributes = { _location: null, "_payment-plan": null };
        const updates = {};
        items.forEach((item, index) => {
          if (item.handle.includes("rental")) {
            updates[`${item.key}`] = 0;
          }
        });
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates, attributes }),
        }).then((response) => {
          window.location.reload();
        });
      });
  }

  removeReformerInclusions(reformerId, timestamp) {
    fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((cart) => {
        const items = cart.items;
        const reformer = cart.items.find(
          (item) => item.variant_id == reformerId && item.properties["_timeStamp"] == timestamp
        );
        const reformerKey = reformer.key;
        const attributes = { _location: null, "_payment-plan": null };
        const updates = {};
        updates[`${reformerKey}`] = 0;
        items.forEach((item, index) => {
          if (
            (item.properties["_bundle-gift"] == reformerId &&
              item.properties["_timeStamp"] == timestamp) ||
            (item.properties["_bundled-variant"] == reformerId &&
              item.properties["_timeStamp"] == timestamp) ||
            (item.properties["_bundle-included"] == reformerId &&
              item.properties["_timeStamp"] == timestamp) ||
            (item.properties["_bundled-product"] == reformerId &&
              item.properties["_timeStamp"] == timestamp)
          ) {
            updates[`${item.key}`] = 0;
          }
        });
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates, attributes }),
        }).then((response) => {
          window.location.reload();
        });
      });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.SOCK_STAND = "44594968723646";
    this.ARCH_SWIVEL = "";
    this.customerTags = window.CUSTOMER_TAGS.split(",");
    this.querySelector("#CartDrawer-RemoveAll a")?.addEventListener(
      "click",
      this.removeAll.bind(this)
    );
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === "cart-items") {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  async removeAll(event) {
    const spinner = event.target.parentElement.querySelector(".loading__spinner");
    spinner?.classList.remove("hidden");

    try {
      const clearResponse = await fetch(window.Shopify.routes.root + "cart/clear.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const attributes = { _location: null, "_payment-plan": null };
      const updateResponse = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: {}, attributes }),
      });

      window.location.reload();
    } catch (error) {
      console.error("Error in removeAll:", error);
    }
  }

  async handleRentalQuantityChange(event, quantity, line) {
    this.enableLoading(line);
    const cart = await this.getCart();
    const theRental = cart.items.find((item) => item.handle === "yr-rental");
    const rentalDeposit = cart.items.find((item) => item.handle === "rental-deposit");
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates: {
            [theRental.key]: quantity,
            [rentalDeposit.key]: quantity,
          },
          sections: this.getSectionsToRender().map((section) => section.section),
        }),
      });
      if (response.ok) {
        await this.updateQuantity(line, quantity);
      } else {
        const errorWrapper = event.target
          .closest("quantity-popover")
          .querySelector(".cart-item__error-text");
        errorWrapper.innerHTML =
          "Maximum online quantity reached. <a href='https://yourreformer.com/pages/commercial#commercial-form'>Contact us</a> for Business requests.";
        event.target.value = rentalDeposit.quantity;
        this.disableLoading(line);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async handleReformerQuantityChange(reformerId, quantity, line, timestamp) {
    this.enableLoading(line);
    const cart = await this.getCart();
    let updates = {};
    cart.items.forEach((item, index) => {
      if (
        (item.properties["_bundled-variant"] == reformerId &&
          item.properties["_timeStamp"] == timestamp) ||
        (item.properties["_bundled-product"] == reformerId &&
          item.properties["_timeStamp"] == timestamp) ||
        (item.properties["_bundle-included"] == reformerId &&
          item.properties["_timeStamp"] == timestamp) ||
        (item.properties["_bundle-gift"] == reformerId &&
          item.properties["_timeStamp"] == timestamp)
      ) {
        updates[item.key] = quantity;
      }
    });
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates,
          sections: this.getSectionsToRender().map((section) => section.section),
        }),
      });
      this.updateQuantity(line, quantity);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  onChange(event) {
    const reformerProperty = event.target
      .closest(".cart-item")
      .querySelector("span[data-property-key='_bundle-product']");
    if (reformerProperty) {
      const reformerId = reformerProperty.getAttribute("data-property-value");
      const timestamp = event.target
        .closest(".cart-item")
        .querySelector("span[data-property-key='_timeStamp']")
        .getAttribute("data-property-value");
      const itemIndex = event.target.closest(".cart-item").getAttribute("data-index");
      const quantity = +event.target.value;
      if (quantity == 0) {
        const reformerDeleteButton = event.target
          .closest(".cart-item")
          .querySelector("cart-remove-button");
        if (reformerDeleteButton) {
          reformerDeleteButton.click();
          return;
        }
      }
      this.handleReformerQuantityChange(reformerId, quantity, itemIndex, timestamp);
      return;
    }
    const rentalProperty = event.target.closest(".cart-item").querySelector("span[data-rental]");
    if (rentalProperty) {
      const itemIndex = event.target.closest(".cart-item").getAttribute("data-index");
      const quantity = +event.target.value;
      if (quantity == 0) {
        const rentalDeleteButton = event.target
          .closest(".cart-item")
          .querySelector("cart-remove-button");
        if (rentalDeleteButton) {
          rentalDeleteButton.click();
          return;
        }
      }
      this.handleRentalQuantityChange(event, quantity, itemIndex);
      return;
    }
    const maxQuantity = event.target.getAttribute("data-max");
    const currentQuantity = event.target.value;
    const errorWrapper = event.target
      .closest("quantity-popover")
      .querySelector(".cart-item__error-text");
    const diff = +maxQuantity - +currentQuantity;
    const submitButton = document.querySelector(
      `.product-form__submit.button[data-variant="${event.target.dataset.quantityVariantId}"]`
    );
    const isRental = event.target.getAttribute("data-rental");
    errorWrapper.textContent = "";

    if (maxQuantity && +maxQuantity > 0 && +currentQuantity > +maxQuantity) {
      event.target.value = +maxQuantity;
      isRental
        ? (errorWrapper.innerHTML = `Maximum online quantity reached. <a href="https://yourreformer.com/pages/commercial#commercial-form">Contact us</a> for Business requests.`)
        : (errorWrapper.textContent = "You can't add more of this product to the cart");
      return;
    }
    if (submitButton) {
      submitButton.setAttribute("data-inventory", diff);
    }
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  toggleCheckoutButton() {
    fetch(window.Shopify.routes.root + "cart.js", { method: "GET" })
      .then((response) => response.json())
      .then((cart) => {
        const checkoutButton = $("#checkout");
        const checkoutButtonMessage = $(".checkout-button__message");
        const isCartEligible = cart && cart.total_price > 10000;

        checkoutButton.prop("disabled", !isCartEligible);
        checkoutButtonMessage.toggleClass("active", !isCartEligible);
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          if (typeof $.fn.slick !== "undefined") {
            if ($(".cart-drawer .footer__inclusions").not(".slick-initialized").length)
              $(".cart-drawer .footer__inclusions").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                variableWidth: true,
                prevArrow: `
                    <div class="slick-prev">
                      <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                      </svg>
                    </div>`,
                nextArrow: `
                    <div class="slick-next">
                      <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                      </svg>
                    </div>`,
              });
          } else {
            console.log("Slick not loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  async getCart() {
    const responseCart = await fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
    });
    return await responseCart.json();
  }

  async checkForFreeGift(cart) {
    const socksTotal = this.checkSocksTotal(cart);

    if (
      socksTotal < 200 &&
      (this.isGiftInTheCart(cart, this.ARCH_SWIVEL) || this.isGiftInTheCart(cart, this.SOCK_STAND))
    ) {
      return await this.removeAllGifts(cart);
    }

    if (
      socksTotal > 400 &&
      ARCH_SWIVEL_AVAILABLE &&
      !this.customerTags.includes("archswivel-received") &&
      !this.isGiftInTheCart(cart, this.ARCH_SWIVEL)
    ) {
      if (this.isGiftInTheCart(cart, this.SOCK_STAND)) {
        await this.removeGifts(cart, this.SOCK_STAND);
      }
      return await this.addGift(this.ARCH_SWIVEL);
    } else if (
      socksTotal >= 200 &&
      socksTotal <= 400 &&
      SOCK_STAND_AVAILABLE &&
      !this.customerTags.includes("sockstand-received") &&
      !this.isGiftInTheCart(cart, this.SOCK_STAND)
    ) {
      if (this.isGiftInTheCart(cart, this.ARCH_SWIVEL)) {
        await this.removeGifts(cart, this.ARCH_SWIVEL);
      }
      return await this.addGift(this.SOCK_STAND);
    } else if (
      socksTotal > 400 &&
      !ARCH_SWIVEL_AVAILABLE &&
      SOCK_STAND_AVAILABLE &&
      !this.customerTags.includes("sockstand-received") &&
      !this.isGiftInTheCart(cart, this.SOCK_STAND)
    ) {
      if (this.isGiftInTheCart(cart, this.ARCH_SWIVEL)) {
        await this.removeGifts(cart, this.ARCH_SWIVEL);
      }
      return await this.addGift(this.SOCK_STAND);
    }

    return cart;
  }

  checkSocksTotal(cart) {
    const SOCKS_IDS = [8282844823742, 8282844692670, 8282842693822];
    return cart.items.reduce((acc, curr) => {
      if (SOCKS_IDS.includes(curr.product_id)) {
        acc += curr.final_line_price / 100;
      }
      return acc;
    }, 0);
  }

  isGiftInTheCart(cart, itemId) {
    return cart.items.some((i) => i.id == itemId && i.properties["_free_b2b"] == "yes");
  }

  async addGift(giftId) {
    const data = {
      items: [
        {
          id: giftId,
          quantity: 1,
          properties: { _free_b2b: "yes" },
        },
      ],
      sections: this.getSectionsToRender().map((section) => section.section),
    };
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async removeGifts(cart, variantId) {
    try {
      let updates = {};
      cart.items.forEach((item) => {
        if (item.variant_id == variantId && item.properties._free_b2b) {
          updates[item.key] = 0;
        }
      });
      const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates,
          sections: this.getSectionsToRender().map((section) => section.section),
        }),
      });
      await response.json();
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async removeAllGifts(cart) {
    try {
      let updates = {};
      cart.items.forEach((item) => {
        if (item.properties._free_b2b) {
          updates[item.key] = 0;
        }
      });
      const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates,
          sections: this.getSectionsToRender().map((section) => section.section),
        }),
      });
      return await response.json();
    } catch (error) {
      console.error("Error:", error);
    }
  }

  formatPrice(price) {
    const regularPrice = (price / 100).toFixed(2);
    return `$${regularPrice} USD`;
  }

  setB2bVariantQuantity(cart, quantity, variantId) {
    if (!variantId || this.tagName == "CART-ITEMS") {
      return;
    }
    const input =
      document.querySelector(
        `.b2b-product-variants-grid-items-item-quantity-input input[data-quantity-variant-id="${variantId}"]`
      ) ||
      document.querySelector(
        `.b2b__product-card-button input[data-quantity-variant-id="${variantId}"]`
      );
    const variantTotalSpan = document.querySelector(
      `.b2b-product-variants-grid-items-item-total-price[data-variant="${variantId}"] span`
    );
    const productTotalSpan =
      variantTotalSpan
        ?.closest(".b2b-product-popup-info")
        .querySelector(".b2b-product-popup-info-summary-total-items span") ||
      document.querySelector(".b2b-product-popup-info-summary-total-items span");
    const productSummarySpan =
      variantTotalSpan
        ?.closest(".b2b-product-popup-info")
        .querySelector(".b2b-product-popup-info-summary-totals span") ||
      document.querySelector(".b2b-product-popup-info-summary-totals span");
    const variant = cart.items.find((item) => item.variant_id == variantId);
    let productTotal = 0;
    let productSummary = 0;
    cart.items.forEach((item) => {
      if (item.product_id == variant.product_id) {
        productSummary += item.final_line_price;
        productTotal += item.quantity;
      }
    });

    if (productTotalSpan) {
      productTotalSpan.textContent = productTotal;
    }
    if (productSummary) {
      productSummarySpan.textContent = this.formatPrice(productSummary);
    }
    if (variant && variantTotalSpan) {
      const variantTotal = this.formatPrice(variant.line_price);
      variantTotalSpan.textContent = variantTotal;
    }

    if (input) {
      input.value = quantity;
    }
  }

  async updateQuantity(line, quantity, name, variantId) {
    const quantityElement =
      document.getElementById(`Quantity-${line}`) ||
      document.getElementById(`Drawer-quantity-${line}`);
    const items = document.querySelectorAll(".cart-item");

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        body,
      });
      const state = await response.text();
      let parsedState = JSON.parse(state);

      const isB2B = parsedState.attributes._fromB2B == "yes" ? true : false;

      if (isB2B) {
        this.toggleCheckoutButton();
        parsedState = await this.checkForFreeGift(parsedState);
        if (this.tagName != "CART-ITEMS") {
          this.setB2bVariantQuantity(await this.getCart(), quantity, variantId);
        }
      }

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute("value");
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      this.classList.toggle("is-empty", parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector("cart-drawer");
      const cartFooter = document.getElementById("main-cart-footer");

      if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
      if (cartDrawerWrapper)
        cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });

      if (!isB2B) {
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace("[quantity]", updatedValue);
          }
        }
        this.updateLiveRegions(line, message);
      }

      const lineItem =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper
          ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(
          cartDrawerWrapper.querySelector(".drawer__inner-empty"),
          cartDrawerWrapper.querySelector("a")
        );
      } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
        cartData: parsedState,
        variantId: variantId,
      });

      if (typeof $.fn.slick !== "undefined") {
        if ($(".cart-drawer .footer__inclusions").not(".slick-initialized").length)
          $(".cart-drawer .footer__inclusions").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            variableWidth: true,
            prevArrow: `
                <div class="slick-prev">
                  <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                  </svg>
                </div>`,
            nextArrow: `
                <div class="slick-next">
                  <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                  </svg>
                </div>`,
          });
      } else {
        console.log("Slick not loaded");
      }
    } catch (error) {
      this.querySelectorAll(".loading__spinner").forEach((overlay) =>
        overlay.classList.add("hidden")
      );
      const errors =
        document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      errors.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(line);
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add("hidden"));
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
